import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-20" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}

import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';

import EpinioCatalogServiceModel from '../models/catalogservices';
import { EPINIO_TYPES } from '../types';

import DataTable from '../components/tables/DataTable.vue';
import type { DataTableColumn } from '../components/tables/types';
import BadgeStateFormatter from '@shell/components/formatter/BadgeStateFormatter.vue';
import LinkDetail from '@shell/components/formatter/LinkDetail.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogservices',
  props: {
    value: {}
  },
  setup(__props: any) {

const store = useStore();

const t = store.getters['i18n/t'];

const props = __props;

const pending = ref<boolean>(true);

onMounted(async () => {
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.SERVICE_INSTANCE });
  pending.value = false;
});

const columns: DataTableColumn[] = [
  {
    field: 'stateDisplay',
    label: 'State',
    width: '100px'
  },
  {
    field: 'nameDisplay',
    label: 'Name'
  },
  {
    field: 'catalog_service',
    label: 'Catalog Service',
    sortable: false
  },
  {
    field: 'catalog_service_version',
    label: 'Catalog Service Version'
  },
  {
    field: 'boundApps',
    label: 'Bound Applications',
    sortable: false
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('epinio.catalogService.detail.servicesTitle', { catalogService: props.value.name })), 1),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createVNode(DataTable, {
      rows: props.value.services,
      columns: columns,
      loading: pending.value
    }, {
      "cell:stateDisplay": _withCtx(({ row }) => [
        _createVNode(BadgeStateFormatter, {
          row: row,
          value: row.stateDisplay
        }, null, 8, ["row", "value"])
      ]),
      "cell:nameDisplay": _withCtx(({ row }) => [
        _createVNode(LinkDetail, {
          row: row,
          value: row.nameDisplay
        }, null, 8, ["row", "value"])
      ]),
      "cell:catalog_service": _withCtx(({ row }) => [
        (row.serviceLocation)
          ? (_openBlock(), _createBlock(LinkDetail, {
              key: 0,
              row: row.serviceLocation,
              value: row.catalog_service
            }, null, 8, ["row", "value"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(row.catalog_service), 1))
      ]),
      "cell:boundApps": _withCtx(({ row }) => [
        (row.applications && row.applications.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.applications, (app, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: app.id
                }, [
                  _createVNode(LinkDetail, {
                    row: app,
                    value: app.meta.name
                  }, null, 8, ["row", "value"]),
                  _cache[0] || (_cache[0] = _createTextVNode()),
                  (index < row.applications.length - 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: app.id + 'i'
                      }, ", "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, " "))
      ]),
      _: 1,
      __: [1,2,3]
    }, 8, ["rows", "loading"])
  ]))
}
}

})